import {ColumnDataType, Resource} from "../../shared/model/resource";

export const rodadaResource: Resource = {
    nomeEntidade: {
        singular: 'Rodada (Tema)',
        plural: 'Rodadas (Temas)'
    },
    fieldPk: 'uuid',
    route: {
        url: 'rodadas',
    },
    colunas: [
        {
            field: 'posicao',
            required: true,
            type: ColumnDataType.Number,
            numberConfiguration: {
                minValue: 0
            },
            sizeColumn: 'col-12',
            unAvailableOnCreate: true
        },
        {
            field: 'nome',
            required: true,
            sizeColumn: 'col-12'
        },
        {
            field: 'descricao',
            label: 'Descrição',
            required: true,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '0_a_50_vulnerabilidade',
            label: '0 a 50 - Vulnerabilidade',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '0_a_50_recomendacao',
            label: '0 a 50 - Recomendação',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '51_a_70_vulnerabilidade',
            label: '51 a 70 - Vulnerabilidade',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '51_a_70_recomendacao',
            label: '51 a 70 - Recomendação',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '71_a_100_vulnerabilidade',
            label: '71 a 100 - Vulnerabilidade',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: '71_a_100_recomendacao',
            label: '71 a 100 - Recomendação',
            required: false,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
    ],
    actions: [],
    availableReferences: []
}
